//@state
interface fileManagementState {
  fileManagement: boolean;
  resource: string;
  resource_id: string;
  attachment_temp_code: Array<object>;
}

export const initialState: fileManagementState = {
  fileManagement: true,
  resource: "",
  resource_id: "",
  attachment_temp_code: [],
};
